export function truncateString(string, toLength) {
  if (string?.length>toLength && toLength) {
    let truncatedString = string.substring(0, toLength).concat('...')
    return truncatedString
  } else {
    return string
  }
}